// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/umweltpakt-bayern-2-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const umweltpaktBayern22DE: PageEntry = {
  id: "post.umweltpakt-bayern-2-2",
  locale: "de",
  slug: "umweltpakt-bayern-2-2",
  seo: {
    title: "Umweltbewusst in die Zukunft! | Dietz GmbH",
    description: "Umweltbewusst in die Zukunft!",
  },
  type: "post",
  h1: "Umweltbewusst in die Zukunft!",
  blocks: [
    { kind: "heading", level: 2, text: "Umweltbewusst in die Zukunft!" },
    { kind: "paragraph", text: "Am 02.09.2020 wurde uns die Urkunde der EMAS-Validierung offiziell von der IHK Coburg übergeben. Die feierliche Übergabe ist ein Meilenstein für die Einführung des Umweltmanagementsystems. Die Urkunde ist ein wichtiger Nachweis dafür, dass wir Umweltbewusstsein und Nachhaltigkeit leben und in den Unternehmensalltag integrieren." }
  ],
};
